import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './shared/i18n';
import './styles/global.css';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element #root not found');
}

// Initialize document direction based on persisted lang (default he)
const storedLang = localStorage.getItem('merkaziya-lang');
const lang = storedLang === 'en' ? 'en' : 'he';
document.documentElement.lang = lang;
document.documentElement.dir = lang === 'he' ? 'rtl' : 'ltr';

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
